import React from 'react';

const ContactMap = () => {
    return (
        <>
            <div className="map-area">
                <iframe 
                    title="Address"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d719074.0744646452!2d-75.80025690000004!3d45.25015655000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cce05b25f5113af%3A0x8a6a51e131dd15ed!2sOttawa%2C%20ON!5e0!3m2!1sen!2sca!4v1744739348427!5m2!1sen!2sca">
                </iframe>
            </div>
        </>
    )
}

export default ContactMap;